import { motion } from "framer-motion";
import Counter from "@/components/common/Counter";
import { COUNTERS } from "@/lib/data";

export default function CountersSection() {
  return (
    <section className="py-20 sm:py-28 relative overflow-hidden" data-testid="counters-section">
      <div className="absolute inset-0 opacity-40 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[400px] rounded-full blur-[160px]"
          style={{ background: "radial-gradient(ellipse, rgba(16,185,129,0.4), transparent 70%)" }} />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-10">
          {COUNTERS.map((c, i) => (
            <motion.div
              key={c.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="text-left"
            >
              <p className="font-poppins text-5xl sm:text-6xl lg:text-7xl font-semibold tracking-tighter text-gradient leading-none">
                <Counter value={c.value} suffix={c.suffix} testId={`counter-${i}`} />
              </p>
              <p className="font-inter text-sm text-white/50 mt-3 uppercase tracking-[0.14em]">{c.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
